module.exports = __webpack_public_path__ + "img/beer.ef979d8c.png";